import { FC } from 'react'
import styles from './index.module.scss'

/*
  Profile ページで使用するカードの width を指定する。
  デフォルトは gap: 16px の 3 カラムレイアウト用の width になっている。
  必要であれば他の値も props で指定できるようにする。
 */
export const ProfileCardSizingContainer: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}
